<template>
  <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
    <b-form
      style="max-width: 500px;"
      role="form"
      @submit.prevent="handleSubmit(submitMessaging)"
    >
      <b-card class="border shadow-sm">
        <h3>Receipt Delivery</h3>
        <p class="text-muted">
          Where would you like your transaction receipts sent from?
        </p>

        <b-form-radio
          v-model="model.sendSystemEmail"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          :value="true"
          >{{ name }}</b-form-radio
        >

        <b-form-radio
          v-model="model.sendSystemEmail"
          :aria-describedby="ariaDescribedby"
          name="some-radios"
          :value="false"
          >Poynt</b-form-radio
        >

        <div class="pt-5" v-if="model.sendSystemEmail">
          <h3>Terminal Receipts</h3>
          <p class="text-muted">
            Selecting {{ name }} will bypass the receipt screen on the Poynt
            terminal and send a receipt to the patient's email on file.
          </p>
          <b-form-radio
            v-model="model.supressTerminalReceipts"
            name="some-radios2"
            :value="true"
            >Poynt Terminal</b-form-radio
          >
          <b-form-radio
            v-model="model.supressTerminalReceipts"
            :aria-describedby="ariaDescribedby"
            name="some-radios2"
            :value="false"
            >{{ name }}</b-form-radio
          >
        </div>
      </b-card>
      <b-row class="pt-3">
          <b-col>
            <b-button type="submit" variant="primary">
        Update Receipt Settings
      </b-button>
          </b-col>
        </b-row>
      
    </b-form>
  </validation-observer>
</template>

<script>
export default {
  name: "receipt-settings",
  props: { company: null, bindReceiptSettings: null },
  inject: ["systemContextService"],
  data: function() {
    return {
      name: null,
      model: null,
      membershipPaymentPlanReminderDaysOptions: [],
    };
  },
  async created() {
    this.name = this.systemContextService.getSystem().name;

    this.model = await this.bindReceiptSettings();

    for (let i = 1; i <= 6; i++) {
      this.membershipPaymentPlanReminderDaysOptions.push({ value: i, text: i });
    }
  },
  methods: {
    submitMessaging() {
      this.$emit("updateReceiptSettings", this.model);
    },
  },
};
</script>

<style></style>
